var _rect, _rect2, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#F6F6F6",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42553_92021)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42553_92021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -10,
    width: 99,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.7812 -9.38965V45.3945H-11.9443V-9.38965H85.7812Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.313726
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42553_92021)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_42553_92021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.15723C23.4362 8.15723 27.8428 12.5638 27.8428 18C27.8428 23.4362 23.4362 27.8428 18 27.8428C12.5638 27.8428 8.15723 23.4362 8.15723 18C8.15724 12.5638 12.5638 8.15724 18 8.15723Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.313726
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_42553_92021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50781 7.50781H28.4882V28.4882H7.50781V7.50781Z",
    fill: "#E5E5E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_42553_92021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 27.8032C23.4138 27.8032 27.8032 23.4138 27.8032 17.9993C27.8032 12.5847 23.4138 8.19531 17.9992 8.19531C12.5847 8.19531 8.19531 12.5847 8.19531 17.9993C8.19531 23.4138 12.5847 27.8032 17.9992 27.8032Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_42553_92021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 7.70312H28.2914V28.2914H7.70312V7.70312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_42553_92021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9962 27.0158C22.9776 27.0158 27.0158 22.9776 27.0158 17.9962C27.0158 13.0148 22.9776 8.97656 17.9962 8.97656C13.0148 8.97656 8.97656 13.0148 8.97656 17.9962C8.97656 22.9776 13.0148 27.0158 17.9962 27.0158Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_42553_92021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48438 8.48438H27.504V27.504H8.48438V8.48438Z",
    fill: "#4A8CFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_42553_92021",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 12,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7447 16.8282L23.2937 14.9655C23.5162 14.7841 23.6858 14.8263 23.6858 15.1616V20.842C23.6858 21.2184 23.4741 21.1753 23.2937 21.0381L20.7447 19.1753V16.8282ZM12.1172 15.1753V19.4106C12.1195 19.8704 12.3044 20.3105 12.631 20.634C12.9577 20.9576 13.3995 21.1382 13.8593 21.1361H20.0358C20.1194 21.1364 20.1996 21.1035 20.259 21.0447C20.3184 20.9859 20.352 20.9059 20.3525 20.8224V16.5871C20.3502 16.1273 20.1653 15.6872 19.8386 15.3636C19.5119 15.0401 19.0701 14.8595 18.6103 14.8616H12.4339C12.3503 14.8613 12.27 14.8942 12.2107 14.953C12.1513 15.0118 12.1177 15.0917 12.1172 15.1753Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_42553_92021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 14.375H24.174V21.6299H11.625V14.375Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42553_92021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomBg);
export default __webpack_public_path__ + "static/media/zoom-bg.bee11ec90727625d49b806b8847db05d.svg";
export { ForwardRef as ReactComponent };